import {
    Note,
    Tone
} from "../model/core";
import { Tonality } from "../model/scales";
import { Predicate } from "./predicate";


export type IsInTonalityPredicate = Predicate<Note | Tone>;
// export type IsInChordPredicate =    Predicate<Note | Tone, chord: Chord)>;
export type IsToneCenterPredicate = Predicate<Note | Tone>;

export type HarmonicPredicates = {
    isInTonality: IsInTonalityPredicate,
    // isInChord: IsInChordPredicate,
    isToneCenter: IsToneCenterPredicate,
    hasTonality: boolean,
}

export function createHarmonicPredicates(
    tonality?: Tonality
): HarmonicPredicates {
    if (!tonality) {
        return {
            isInTonality: () => false,
            // isInChord: () => false,
            isToneCenter: () => false,
            hasTonality: false,
        };
    }

    return {
        isInTonality: (n: Note) => tonality.containsNote(n),
        // isInChord: (n: Note | Tone, chord: Chord) => chord.contains(n),
        isToneCenter: (n: Note | Tone) => tonality.center
            && tonality.center.index === (n instanceof Note ? n.getTone() : n).index,
        hasTonality: true,
    };
}